const FilterSidebar = Vue.component('filter-sidebar', {
	props: {
		initialFilters: Array | Object,
		totalResults: Number,
	},
	data() {
		return {
			filters: this.initialFilters,
		};
	},
	computed: {
		selectedRegionsIDs() {
			return this.filters
				.find((el) => el.slug === 'region')
				.terms.filter((term) => term.checked)
				.map((term) => term.term_id);
		},
	},
	methods: {
		showFilter(filter) {
			return !(filter.slug === 'country' && this.selectedRegionsIDs.length === 0);
		},
		applyFilters() {
			/* Updates the Filters */
			this.$emit('filters-updated', this.filters);
		},
		termClicked(filter, term) {
			// Make the Region filter behave like a radio button group
			if (filter.slug === 'region') {
				this.filters = this.filters.map((f) => {
					if (!Array.isArray(f.terms)) return f;

					f.terms.map((t) => {
						if (t.slug !== term.slug) t.checked = false;
					});

					return f;
				});

				// modify the country filter to open together with region
				this.filters.forEach(filter => {
					if (filter.slug === 'country') {
						filter.open = true
					}
				})

				// make sure to skip the filter on the right
				return;
			}

			this.$emit('filters-updated', this.filters);
		},
		showCountry(filterSlug, countryTerm) {
			return filterSlug !== 'country' || this.selectedRegionsIDs.length === 0
				? true
				: this.selectedRegionsIDs.includes(countryTerm.parent);
		},
		resetFilters() {
			this.filters.forEach((f) => {
				if (!Array.isArray(f.terms)) return;

				f.terms.forEach((t) => (t.checked = false));
			});

			this.$emit('filters-reset', this.filters);
		},
	},
	template: '#pst-sds-filter-sidebar',
});

export const PXSdsSearch = (function () {
	'use strict';

	let app;

	function init() {
		if (!document.getElementById('poly-sds-search')) return;

		app = new Vue({
			el: '#poly-sds-search',
			components: { FilterSidebar },
			data() {
				return {
					query: '',
					results: [],
					filtersState: [],
					searchInitiated: false,
					isLoading: false,
				};
			},
			computed: {
				totalResults() {
					return this.results.length;
				},
			},
			created() {
				let queryParams = PixelsmithModules.Helpers.getUrlParams(window.location.search);

				if (queryParams.sdssearchquery) this.query = queryParams.sdssearchquery;
			},
			mounted() {
				// this.fetchResults();
			},
			methods: {
				handleSearchBlur(e){
					// this.fetchResults(e);
				},
				shareFile(file) {
					let attachmentsEl = document.getElementById('polywater-modal-share-attachments');
					let filenameEl = document.getElementById('polywater-modal-share-filename');
					let attachmentInput = document.createElement('input');

					attachmentInput.setAttribute('type', 'hidden');
					attachmentInput.setAttribute('name', 'attachments[]');
					attachmentInput.value = file.ID;

					filenameEl.innerText = file.filename;
					attachmentsEl.appendChild(attachmentInput);

					MicroModal.show('polywater-modal-share');
				},
				copyToClipboard(url, event) {
					let copyLinkNote = event.currentTarget.querySelector('.copy-link-note');
					navigator.clipboard.writeText(url).then(function() {
						copyLinkNote.style.opacity = 1;
						setTimeout(() => {
							copyLinkNote.style.opacity = 0;
						}, 1000);
					});
				},
				fetchResults($ev) {
					if ($ev) $ev.preventDefault();

					if (!this.searchInitiated) this.searchInitiated = true;

					this.results = [];
					this.isLoading = true;

					let queryParams = PixelsmithModules.Helpers.getUrlParams(window.location.search);
					let postData = {
						s: this.query,
						filters: this.filtersState,
						currentSiteLanguage: PXConstants.current_site_language
					};

					if (queryParams.lang) postData.lang = queryParams.lang;

					axios
						.post('/wp-json/wp/v2/sdssearch', postData)
						.then((response) => {
							this.results = response.data;
							this.isLoading = false;
						})
						.catch((error) => console.log(error));
				},
				filtersUpdatedHandler(newState) {
					this.filtersState = newState;
					this.fetchResults();
				},
				resetFilters(newFiltersState) {
					this.query = '';
					this.results = [];
					this.searchInitiated = false;
					this.filtersState = [];
					this.searchInitiated = false;
					this.isLoading = false;
					$("#pst-filter-language-sliding-content").find('input').each(function(){
						$(this).prop("checked", false);
					});
					history.pushState({}, document.title, window.location.pathname);
				},
				fetchAllResults() {
					this.filtersState = [];
					this.fetchResults();
				},
			},
		});
	}

	return {
		init: init,
	};
})();